import { Route, Switch } from 'react-router-dom';
import { Box, Toolbar } from '@mui/material';

// Components
import AdminAppBar from 'components/navigation/AdminAppBar';
import AdminDrawer from 'components/navigation/AdminDrawer';
import AdminTabs from 'components/navigation/AdminTabs';

// Pages
import Admin from 'pages/Admin';
import AdminEvents from 'pages/AdminEvents';
import Audit from 'pages/admin/audit/Audit';
import OrderLookup from 'pages/admin/OrderLookup';
import ErrorLog from 'pages/admin/errorLog/ErrorLog';
import Hosts from 'pages/Hosts';
import Users from 'pages/admin/user/User';
import ConnectLookup from 'pages/admin/ConnectLookup';
import Notification from 'pages/admin/notification/Notification';
import Reports from 'pages/admin/Reports';
import Calculator from 'pages/admin/Calculator';
import HostPricing from 'pages/hostPricing/HostPricing';
import HostConnectDetails from 'pages/admin/HostConnectDetails';
import PageNotFound from 'pages/PageNotFound';
import McpConnections from 'pages/admin/mcp/McpConnections';

export default function AdminNavigator() {
    return (
        <>
            <AdminAppBar />
            <Box display="flex" height="100%">
                <Box sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}>
                    <AdminDrawer />
                </Box>

                <Box
                    display="flex"
                    flexGrow={1}
                    flexDirection="column"
                    height="100%"
                    maxWidth={'100%'}
                    minWidth={0}
                >
                    <Toolbar />

                    <Box sx={{ display: { xs: 'block', sm: 'block', md: 'none' } }}>
                        <AdminTabs />
                    </Box>

                    <Box display="flex" flexGrow={1} flexDirection="column">
                        <Switch>
                            <Route exact path={'/admin/'} component={Admin} />
                            <Route exact path={'/admin/events'} component={AdminEvents} />
                            <Route exact path={'/admin/operations'} component={Audit} />
                            <Route exact path={'/admin/orders'} component={OrderLookup} />
                            <Route exact path={'/admin/error_log'} component={ErrorLog} />
                            <Route exact path={'/admin/users'} component={Users} />
                            <Route exact path={'/admin/connect'} component={ConnectLookup} />
                            <Route exact path={'/admin/notifications'} component={Notification} />
                            <Route exact path={'/admin/reports'} component={Reports} />
                            <Route exact path={'/admin/calculator'} component={Calculator} />
                            <Route exact path={'/admin/mcp'} component={McpConnections} />

                            <Route exact path={'/admin/hosts'} component={Hosts} />
                            <Route
                                exact
                                path={'/admin/hosts/:hostId/host_pricing'}
                                component={HostPricing}
                            />
                            <Route
                                exact
                                path={'/admin/hosts/:hostId/host_connect'}
                                component={HostConnectDetails}
                            />

                            <Route path="*" component={PageNotFound} />
                        </Switch>
                    </Box>
                </Box>
            </Box>
        </>
    );
}
